import { Expose } from 'class-transformer';

export enum SOCIAL_MEDIA_SHARE_STATUS {
  PENDING = 1,
  PROCESSING = 2,
  COMPLETED = 3,
  FAILED = 4,
}

export class SocialMediaShareGeneration {
  @Expose()
  id!: string;

  @Expose()
  status!: SOCIAL_MEDIA_SHARE_STATUS;

  @Expose({ name: 'full_image_url' })
  imageUrl!: string | null;

  @Expose({ name: 'full_review_open_graph_url' })
  reviewOpenGraphUrl!: string;

  @Expose({ name: 'error_message' })
  errorMessage!: string;

  @Expose({ name: 'created_at' })
  createdAt!: string;

  @Expose({ name: 'updated_at' })
  updatedAt!: string;
}
